import css from 'styled-jsx/css';

const styles = css.global`.c2c-video {
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 325px;
  border-radius: 4px;
  display: flex;
}

.c2c-video .c2c-video-overlay {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.c2c-video .c2c-video-start {
  background: none;
  border: 0;
  outline: none;
  cursor: pointer;
  position: relative;
  z-index: 2;
}

.c2c-video .c2c-video-placeholder {
  color: #fff;
  font-family: 'SantanderMicroText';
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
  margin-top: 24px;
  max-width: 500px;
  position: relative;
  z-index: 2;
}

.c2c-video .c2c-thumbnail {
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
}

.c2c-video .c2c-overlay-bg {
  background: rgba(68, 68, 68, 0.8);
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.c2c-video .c2c-video-player {
  display: none;
  width: 100%;
  height: 100%;
}

.c2c-video .c2c-video-player.enabled {
  display: block;
}

@media (min-width: 992px) {
  .c2c-video {
    max-width: 727px;
    height: 507px;
  }
}
`;

export default styles;